import {
  initMixpanel as sharedInitMixpanel,
  trackMixpanelEvent as sharedTrackEvent,
  resetMixpanelSession as sharedResetSession,
  isMixpanelReady,
} from '@web-store-platforms/analytics';
import { Dict } from 'mixpanel-browser';
import { getEnvVariable } from '@/lib/getEnvVariable';
import { enrichOptions } from './eventDataUtils';

const MIXPANEL_TOKEN = getEnvVariable('NEXT_PUBLIC_MIXPANEL_TOKEN', process.env.NEXT_PUBLIC_MIXPANEL_TOKEN);

export const initMixpanel = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!MIXPANEL_TOKEN) {
      console.warn('Mixpanel token is missing! Check your configuration');
      reject(new Error('Mixpanel token is missing'));
      return;
    }

    try {
      sharedInitMixpanel({
        token: MIXPANEL_TOKEN,
        debug: process.env.NODE_ENV === 'development',
      });
      resolve();
    } catch (error) {
      console.error('Failed to initialize Mixpanel:', error);
      reject(error);
    }
  });
};

export { isMixpanelReady as isMixpanelInitialized };

export const resetMixpanelSession = (): void => {
  try {
    if (isMixpanelReady()) {
      sharedResetSession();
    }
  } catch (error) {
    console.error('Failed to reset Mixpanel session:', error);
  }
};

export const trackMixpanelEvent = (eventName: string, options: Dict): void => {
  try {
    if (!isMixpanelReady()) {
      console.warn('Mixpanel not available, skipping event tracking:', eventName);
      return;
    }
    const enrichedOptions = enrichOptions(options, true);
    sharedTrackEvent(eventName, enrichedOptions);
  } catch (error) {
    console.error('Failed to send Mixpanel event:', error);
  }
};
